import { FooterArch } from 'components/svgs/FooterArch.svg'
interface FooterProps {
  className?: string
}
export const Footer = (props: FooterProps) => {
  const { className } = props
  return <FooterArch className={`w-full ${className}`} width="100%" />
}
